var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-banner"},[_c('img',{attrs:{"src":_vm.bannerObj[_vm.bannerType],"alt":""}}),_c('div',{staticClass:"g-banner-title"},[_c('h1',[_vm._v(_vm._s(_vm.titleObj[_vm.bannerType]))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }